exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dealer-search-header{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;padding-bottom:20px}.dealer-search-header .dealer-search-label{font-size:1.8rem;font-weight:700}.dealer-search-header .cancel-dealer-search{height:9px;margin-right:4px;width:9px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/dealer-search/components/dealer-search-header.scss
// module id = 5101
// module chunks = 0